import { useTranslation } from "react-i18next";
import { Modifydetail } from "../../../../../../redux/apiSpecifications/apiCrud";

interface IPracticeNoteModifiedDescriptionProps {
  modifyDetailsJson: Modifydetail[];
}

const PracticeNoteModifiedDescription = ({
  modifyDetailsJson,
}: IPracticeNoteModifiedDescriptionProps) => {
  const { t } = useTranslation();

  const practiceNoteOld = modifyDetailsJson.find(
    (_) => _.key === "practice_note-old"
  );
  const practiceNoteNew = modifyDetailsJson.find(
    (_) => _.key === "practice_note-new"
  );

  return (
    <>
      {t(`historical-actions-practice-note-modified-description`, {
        practiceNoteOld: practiceNoteOld?.value ?? "",
        practiceNoteNew: practiceNoteNew?.value ?? "",
      })}
    </>
  );
};
export default PracticeNoteModifiedDescription;
